import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';

import Button from './Button';

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);

  const handleLogout = () => {
    localStorage.removeItem('authToken');
    navigate('/login-screen');
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const toggleUserMenu = () => {
    setIsUserMenuOpen(!isUserMenuOpen);
  };

  const isLoginPage = location.pathname === '/login-screen';

  if (isLoginPage) {
    return null;
  }

  return (
    <header className="fixed top-0 left-0 right-0 bg-card border-b border-border z-50 shadow-spiritual-sm">
      <div className="flex items-center justify-between h-16 px-4 lg:px-6">
        {/* Logo, Brand, and Dashboard Button */}
        <div className="flex items-center space-x-6">
          <div className="flex items-center space-x-2 cursor-pointer" onClick={() => navigate('/dashboard')}>
            <div className="w-14 h-auto flex items-center justify-center">
              <img src="assets/images/sarvaDharma-logo.png" alt="Logo" className="w-180 h-auto" />  
            </div>
            <div className="hidden sm:block">
              <h1 className="font-heading font-semibold text-lg text-foreground">
                Tamil Nadu Prasanthi Seva
              </h1>
              <p className="font-caption text-xs text-muted-foreground">
                Registration Management
              </p>
            </div>
          </div>
          {/* Desktop Navigation - Dashboard Button */}
          <nav className="hidden md:flex items-center">
            <Button
              variant={location.pathname === '/dashboard' ? 'default' : 'ghost'}
              onClick={() => navigate('/dashboard')}
             className="inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 bg-primary text-primary-foreground hover:bg-accent h-10 px-4 py-2"
            >
              Dashboard
            </Button>
          </nav>
        </div>

        {/* User Menu and Mobile Toggle */}
        <div className="flex items-center space-x-3">
          {/* User Profile Menu */}
          <div className="relative">
            <Button
              variant="ghost"
              size="sm"
              onClick={toggleUserMenu}
              className="flex items-center space-x-2"
            >
              <div className="w-8 h-8 bg-primary rounded-full flex items-center justify-center">
                <Icon name="User" size={16} className="text-primary-foreground" />
              </div>
              <span className="hidden sm:inline font-medium">SAIRAM</span>
              <Icon 
                name="ChevronDown" 
                size={16} 
                className={`transition-transform ${isUserMenuOpen ? 'rotate-180' : ''}`} 
              />
            </Button>

            {/* User Dropdown Menu */}
            {isUserMenuOpen && (
              <div className="absolute right-0 mt-2 w-48 bg-popover border border-border rounded-lg shadow-spiritual-md z-60 animate-fade-in">
                <div className="py-2">
                  <div className="px-4 py-2 border-b border-border">
                    <p className="font-medium text-sm text-popover-foreground">SAIRAM</p>
                    <p className="text-xs text-muted-foreground">sai@prasanthiseva.org</p>
                  </div>
                  <button
                    onClick={() => {
                      setIsUserMenuOpen(false);
                      // Navigate to profile if needed
                    }}
                    className="w-full text-left px-4 py-2 text-sm text-popover-foreground hover:bg-muted transition-colors flex items-center space-x-2"
                  >
                    <Icon name="Settings" size={16} />
                    <span>Settings</span>
                  </button>
                  <button
                    onClick={() => {
                      setIsUserMenuOpen(false);
                      handleLogout();
                    }}
                    className="w-full text-left px-4 py-2 text-sm text-error hover:bg-muted transition-colors flex items-center space-x-2"
                  >
                    <Icon name="LogOut" size={16} />
                    <span>Logout</span>
                  </button>
                </div>
              </div>
            )}
          </div>

          {/* Mobile Menu Toggle */}
          <Button
            variant="ghost"
            size="sm"
            onClick={toggleMobileMenu}
            className="md:hidden"
          >
            <Icon name={isMobileMenuOpen ? "X" : "Menu"} size={20} />
          </Button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-card border-t border-border shadow-spiritual-md animate-fade-in">
          <nav className="py-4 px-4 space-y-2">
            <Button
              variant={location.pathname === '/dashboard' ? 'default' : 'ghost'}
              onClick={() => {
                navigate('/dashboard');
                setIsMobileMenuOpen(false);
              }}
              fullWidth
              className="justify-start"
            >
              <Icon name="LayoutDashboard" size={18} className="mr-3" />
              Dashboard
            </Button>
          </nav>
        </div>
      )}

      {/* Overlay for mobile menu */}
      {isMobileMenuOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-25 z-40 md:hidden"
          onClick={() => setIsMobileMenuOpen(false)}
        />
      )}

      {/* Overlay for user menu */}
      {isUserMenuOpen && (
        <div
          className="fixed inset-0 z-50"
          onClick={() => setIsUserMenuOpen(false)}
        />
      )}
    </header>
  );
};

export default Header;